import React from 'react'
import productMapping from './integration-guides/product-mapping'
import {
  Row,
  Col,
  TextDisplay,
  DocumentIcon,
  SettingsIcon,
  PlayIcon,
  CaptionText,
  Button,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { recordDynamicEvent } from '../../../components/common/analytics/utils/record-dynamic-event'
import { saveBannerProgress } from '../../../utils/session-utils'
import IconCard from '../../../components/common/cards/icon-card'
import { useApplicationContext } from '../../../context/ApplicationContext'

export default function IntegrationGuide({
  setBannerPage,
  productIntegration,
}) {
  const {
    csrf,
    logger,
    enviroment,
    setCurrentEnvironment,
    setReloadPage,
    setCurrentBannerStep,
  } = useApplicationContext()
  const productTitle = `onboarding-banner.product.${productIntegration}.title`
  const productCaption = `onboarding-banner.product.${productIntegration}.caption`

  recordDynamicEvent(`onboarding_banner,click,${productIntegration}`)

  return (
    <>
      <Row>
        <Col xs={10}>
          <TextDisplay
            name="integration-guide"
            className="banner-title"
            label=""
            value={<Message id={productTitle} />}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={10}>
          <CaptionText className="caption-ob-subtitle">
            <Message id="onboarding-banner.integrationGuideHelperText" />
          </CaptionText>
        </Col>
      </Row>
      <br />
      <Row>
        {productMapping[productIntegration].docs && (
          <Col xs={4}>
            <IconCard
              Icon={DocumentIcon}
              cardHref={productMapping[productIntegration].docs}
              headerText={'onboarding-banner.integration.devdocs.title'}
              bodyText={productCaption}
              dataTestId="devDocs"
            />
          </Col>
        )}
        {productMapping[productIntegration].builder && (
          <Col xs={4}>
            <IconCard
              Icon={SettingsIcon}
              cardHref={productMapping[productIntegration].builder}
              headerText={'onboarding-banner.integration.builder.title'}
              bodyText={'onboarding-banner.integration.builder.caption'}
              dataTestId="integrationBuilder"
            />
          </Col>
        )}
        {productMapping[productIntegration].apex && (
          <Col xs={4}>
            <IconCard
              Icon={SettingsIcon}
              cardHref={productMapping[productIntegration].apex}
              headerText={'onboarding-banner.integration.apex.title'}
              bodyText={'onboarding-banner.integration.apex.caption'}
              dataTestId="apexTool"
            />
          </Col>
        )}
        {productMapping[productIntegration].postman && (
          <Col xs={4}>
            <IconCard
              Icon={SettingsIcon}
              cardHref={productMapping[productIntegration].postman}
              headerText={'onboarding-banner.integration.postman.title'}
              bodyText={'onboarding-banner.integration.postman.caption'}
              dataTestId="postman"
            />
          </Col>
        )}
        {productMapping[productIntegration].tutorial && (
          <Col xs={4}>
            <IconCard
              Icon={PlayIcon}
              cardHref={productMapping[productIntegration].tutorial}
              headerText={'onboarding-banner.integration.video.title'}
              bodyText={'onboarding-banner.integration.video.caption'}
              dataTestId="videoTutorials"
            />
          </Col>
        )}
      </Row>
      <br />
      <Row>
        <Col>
          <Button
            size="md"
            secondary
            onClick={() => {
              const sessionObject = {
                bannerPage: 2,
              }
              saveBannerProgress(csrf, logger, sessionObject)
              setBannerPage(2)
              setCurrentBannerStep(sessionObject)
              if (enviroment === 'live') {
                setCurrentEnvironment('sandbox')
                setReloadPage('yes')
              }
            }}
          >
            <Message id="onboarding-banner.integration.next.button" />
          </Button>
        </Col>
      </Row>
    </>
  )
}
